import { browserHistory } from 'react-router';
import { get } from 'lodash';
import Axios from './../../common/helpers/axiosUtil';

const basePath = '/apps/ptb';

export const isLegacyChrome = () => {
  const chromeWordIdx = navigator.userAgent.indexOf('Chrome');
  if (chromeWordIdx !== -1) {
    const [version] = navigator.userAgent.substring(chromeWordIdx + 7).split(' ');
    return parseInt(version, 10) < 92;
  }
  return false;
};

export function goToBobSummaryPage(encryptedTaxId) {
  browserHistory.push({ pathname: `${basePath}/bob/${encryptedTaxId}` });
}

export function goToLoginPage() {
  browserHistory.push({ pathname: `${basePath}/login` });
}

export function goToLogoutPage() {
  // browserHistory.push({ pathname: `${basePath}/logout` })
}

export function navigateToAppRoutes(encryptedTaxId, accessLevel, configs = {}, path) {
  const dashboardAccess = get(configs.features, 'bobDashboard.dashboard', false);
  if (path) {
    browserHistory.push({ pathname: `${basePath}/${path}/${encryptedTaxId}` });
  } else if (dashboardAccess) {
    browserHistory.push({ pathname: `${basePath}/dashboard/${encryptedTaxId}` });
  } else {
    accessLevel === 'Minimum' || accessLevel === 'Restricted'
      ? browserHistory.push({ pathname: `${basePath}/quotes/${encryptedTaxId}` })
      : browserHistory.push({ pathname: `${basePath}/bob/${encryptedTaxId}` });
  }
}
export async function goToHomePage(encryptedTaxId, accessLevel, userId, configs = {}, path) {
  const showReviewPage = get(configs.features, 'enableSelfService', false);
  if (showReviewPage) {
    const url = `/apps/ptb/api/accountDetails/updateContact/flag`;
    Axios.get(url)
      .then(data => {
        if (!data) {
          navigateToAppRoutes(encryptedTaxId, accessLevel, configs, path);
        } else {
          browserHistory.push({ pathname: `${basePath}/review-contact-details/${encryptedTaxId}` });
        }
      })
      .catch(() => {
        navigateToAppRoutes(encryptedTaxId, accessLevel, configs, path);
      });
  } else {
    navigateToAppRoutes(encryptedTaxId, accessLevel, configs, path);
  }
}

export function goToAdminPage() {
  browserHistory.push({ pathname: `${basePath}/admin` });
}

export function goToActivePage(path, encryptedTaxId, accessLevel, userId, queryParams, configs = {}) {
  switch (path) {
    case 'clients':
      path = 'bob';
      break;
    case 'applications':
      path = 'applications';
      break;
    case 'renewals':
      path = 'bob/renewals';
      break;
    case 'agentConnect':
      path = 'ac/listing';
      break;
    case 'contracting':
      path = 'accountdetails';
      queryParams.tab = 'Appointments';
      break;
    case 'appointments':
      path = 'accountdetails';
      queryParams.tab = 'Medicare RTS Status';
      break;
    case 'medicaresupplies': 
      path = 'medicareSupplies';
      break;
    case 'login':
      this.goToLoginPage();
      return;
    default:
      if (path === '') {
        this.goToHomePage(encryptedTaxId, accessLevel, userId, configs);
      }
  }

  let routeInfo = {
    pathname: path === 'contactus' ? `${basePath}/${path}/default` : `${basePath}/${path}/${encryptedTaxId}`,
  };

  if (queryParams) {
    routeInfo.query = queryParams;
  }
  browserHistory.push(routeInfo);
}
